import { render, staticRenderFns } from "./colorTitle.vue?vue&type=template&id=0e48980b&scoped=true&"
import script from "./colorTitle.vue?vue&type=script&lang=js&"
export * from "./colorTitle.vue?vue&type=script&lang=js&"
import style0 from "./colorTitle.vue?vue&type=style&index=0&id=0e48980b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e48980b",
  null
  
)

export default component.exports